import { useParams } from 'react-router-dom';

import { useUpdateRegistration } from '../../../../../screens/registration/useRegistrationForm/useUpdateRegistration';
import useStore from '../../../../../hooks/useStore';
import { SubmitPayload } from '../../../../../screens/registrationV2025/components/formBackButton';
import { Ventilasjon } from '../../../../../types/registration/userInput';

import { VentilasjonFormData } from './types';

export const useVentilasjonSubmit = () => {
  const { registrationId } = useParams();
  const { updateRegistration, updateIsLoading, updateError } = useUpdateRegistration(registrationId);
  const store = useStore();
  const userInput = store.getState().register.userInput;

  const onSubmit = ({ data, onSuccess }: SubmitPayload<VentilasjonFormData>) => {
    const ventilasjon: Ventilasjon = {
      ventilasjonType: data.ventilasjonType || undefined,
      gjenvinningAvVarme: data.gjenvinningAvVarme || undefined,
      gjenvinningsType: data.gjenvinningsType || undefined,
      installasjonsAr: data.installasjonsAr?.installasjonsAr || undefined,
      vetInstallasjonsAr: data.installasjonsAr?.vetInstallasjonsAr ?? undefined,
      serviceGjennomfortSiste2Ar: data.serviceGjennomfortSiste2Ar || undefined
    };

    updateRegistration(
      { registrationId: registrationId, userInput: { ...userInput, ventilasjon } },
      {
        onSuccess: onSuccess
      }
    );
  };

  return { onSubmit, isLoading: updateIsLoading, updateError };
};
